export default "# FAQs\n";